import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { RecoverPassword } from './components/RecoverPassword'
import AuthStepper from './components/AuthStepper'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      {/* <Route path='registration' element={<Registration />} /> */}
      <Route path='registration' element={<AuthStepper />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='recover-password' element={<RecoverPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
